export { default } from "./Modal.component";
